'use client'

import type { NextPage } from 'next'
import { useState } from 'react'
import { OptionElement } from 'componentsUnits/optionsList'
import styles from './EntryComponent.module.scss'
import EntryTypeComponent from 'componentsUnits/entryTypeComponent'

interface Props {
  type: string
  options?: OptionElement[]
  children?: JSX.Element
}

const EntryComponentContainer: NextPage<Props> = (props: Props) => {
  const [optionsVisible, setOptionsVisible] = useState<boolean>(false)

  return (
    <div className={styles.container}>
      <EntryTypeComponent
          onClick={() => setOptionsVisible(true)}
          onClose={() => setOptionsVisible(false)}
          onOptionClick={() => setOptionsVisible(false)}
          options={props.options ?? []}
          title={props.type}
          optionsVisible={optionsVisible} />

      {props.children}
    </div>
  )
}

export default EntryComponentContainer
